<template>
    <div id="dash-root">
        <div class="mb-4 d-flex" :class="fortnoxAuthenticated === false ? '' : 'justify-content-end'" role="status" aria-live="polite">
            <div v-if="fortnoxAuthenticated === false" class="alert alert-danger text-red-500 w-100 d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                <div class="d-flex align-items-center">
                    <strong>Fortnox-status:</strong>
                    <i class="fa fa-exclamation-triangle text-warning ml-2" aria-hidden="true"></i>
                    <span class="ml-2">{{ fortnoxStatusMessage }}</span>
                </div>
                <div class="mt-3 mt-md-0">
                    <button type="button" class="btn btn-sm btn-success mr-2" :disabled="fortnoxRetryLoading" @click="retryFortnoxAuth">Försök igen</button>
                    <a :href="fortnox_auth_url" class="btn btn-sm btn-success">Autentisera igen</a>
                </div>
            </div>

            <div v-else class="badge d-inline-flex align-items-center px-2 py-1" :class="fortnoxAuthenticated === true ? 'badge-success' : 'badge-info'">
               {{ fortnoxStatusMessage }}
            </div>
        </div>

        <admin-create-dash-component v-for="(dashpart, index) in dashparts" class="panel panel-flat"
                                        :part="dashpart"
                                        :key="index">
        </admin-create-dash-component>
    </div>

</template>

<script>

    export default {
        props: ['admin_id', 'admin_name', 'route_refresh', 'fortnox_auth_status_url', 'fortnox_retry_auth_url', 'fortnox_auth_url'],
        name: "admin-dash",
        data () {
            return {
                dashparts: [],
                fortnoxAuthenticated: null,
                fortnoxStatusMessage: 'Kontrollerar Fortnox..',
                fortnoxRetryLoading: false
            };
        },
        mounted () {
            this.loadDashboard();
            this.loadFortnoxStatus();
        },
        methods: {
            setFortnoxState(authenticated, message = null) {
                this.fortnoxAuthenticated = authenticated;

                if (message) {
                    this.fortnoxStatusMessage = message;
                    return;
                }

                if (authenticated === true) {
                    this.fortnoxStatusMessage = 'Fortnox ansluten';
                    return;
                }

                if (authenticated === false) {
                    this.fortnoxStatusMessage = 'Inte autentiserad. Försök igen eller autentisera igen.';
                    return;
                }

                this.fortnoxStatusMessage = 'Kontrollerar Fortnox..';
            },
            loadDashboard() {
                let self = this;
                axios.get(this.route_refresh)
                    .then(function (response) {
                        self.dashparts = response.data;
                    })
                    .catch(function () {
                    });
            },
            loadFortnoxStatus() {
                let self = this;
                this.setFortnoxState(null, 'Kontrollerar Fortnox..');

                axios.get(this.fortnox_auth_status_url)
                    .then(function (response) {
                        self.setFortnoxState(Boolean(response.data.authenticated));
                    })
                    .catch(function () {
                        self.setFortnoxState(false, 'Kunde inte hämta Fortnox-status.');
                    });
            },
            retryFortnoxAuth() {
                let self = this;
                this.fortnoxRetryLoading = true;
                this.setFortnoxState(null, 'Försöker igen...');

                axios.post(this.fortnox_retry_auth_url, {})
                    .then(function (response) {
                        self.setFortnoxState(Boolean(response.data.authenticated));
                    })
                    .catch(function () {
                        self.setFortnoxState(false, 'Nytt försök misslyckades. Autentisera igen.');
                    })
                    .finally(function () {
                        self.fortnoxRetryLoading = false;
                    });
            }
        }
    }
</script>

<style scoped>

</style>
